import axios from '../config/axiosConfig';

const API_URL = '/auth/';

// Get all users (admin only)
const getUsers = async () => {
  const response = await axios.get(API_URL + 'users');
  return response.data;
};

// Get users by team
const getUsersByTeam = async (team) => {
  const response = await axios.get(API_URL + 'users/team/' + team);
  return response.data;
};

// Update user (admin only)
const updateUser = async (userId, userData) => {
  const response = await axios.put(API_URL + 'users/' + userId, userData);
  return response.data;
};

// Activate user (admin only)
const activateUser = async (userId) => {
  const response = await axios.put(API_URL + 'users/' + userId, { isActive: true });
  return response.data;
};

// Deactivate user (admin only)
const deactivateUser = async (userId) => {
  const response = await axios.put(API_URL + 'users/' + userId, { isActive: false });
  return response.data;
};

// Change user role (admin only)
const changeUserRole = async (userId, role, team) => {
  const response = await axios.put(API_URL + 'users/' + userId, { role, team });
  return response.data;
};

// Delete user (admin only - soft delete)
const deleteUser = async (userId) => {
  const response = await axios.delete(API_URL + 'users/' + userId);
  return response.data;
};

// Get current user profile
const getProfile = async () => {
  const response = await axios.get(API_URL + 'me');
  return response.data;
};

// Update current user profile
const updateProfile = async (userId, profileData) => {
  const response = await axios.put(API_URL + 'profile', profileData);
  return response.data;
};

// Change password
const changePassword = async (userId, passwordData) => {
  const response = await axios.put(API_URL + 'change-password', passwordData);
  return response.data;
};

// Create user (admin only)
const createUser = async (userData) => {
  const response = await axios.post(API_URL + 'register-admin', userData);
  return response.data;
};

const userService = {
  getUsers,
  getUsersByTeam,
  updateUser,
  activateUser,
  deactivateUser,
  changeUserRole,
  deleteUser,
  getProfile,
  updateProfile,
  changePassword,
  createUser
};

export default userService;
